import { Row, Col } from 'reactstrap';

import { CustomButton } from '@shared/buttons';
import useTranslation from '@shared/hooks/useTranslation';
import {
  CloseIcon,
} from '@shared/icons';

import '../ForgotPasswordModal.scss';

type IForgotPasswordContent = {
  onToggle: () => void;
};

const PasswordChangedContent = ({ onToggle }: IForgotPasswordContent) => {
  const title = useTranslation('forgotPassword.password_changed.title');
  const description = useTranslation('forgotPassword.password_changed.description');
  const goToLogin = useTranslation('forgotPassword.password_changed.button.go_to_login');

  return (
    <div className="password-changed-content-container">
      <Row className="mb-3">
        <Col className="fp-close-button-style">
          <a aria-label="Close" role="button" href="#" onClick={onToggle}><CloseIcon /></a>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="s2 password-changed-modal-title mb-5">{title}</div>
          <div className="b1 mb-4">{description}</div>
          <CustomButton
            id="btn-send"
            color="primary"
            className="btn-lg go-to-login-btn"
            onClick={onToggle}
          >
            {goToLogin}
          </CustomButton>
        </Col>
      </Row>
    </div>
  );
};

export default PasswordChangedContent;
